export enum ChannelTypeEnum {
  Wecom = "QW",
  Wechat = "WECHAT",
  Email = "MAIL",
  WhatsApp = "WHATSAPP",
}

export enum ServiceType {
  /** HOOK协议 */
  HOOK = "HOOK",
  /** IPAD协议 */
  IPAD = "IPAD",
  /** 微信 */
  WECHAT_PC = "WECHAT_PC",
  /** 艾客 */
  AIKE = "AIKE",
  /** WhatsApp */
  SALE_SMARTLY = "SALE_SMARTLY",
}

export enum FrontEndServiceType {
  /** HOOK协议 */
  PC = "pc",
  /** IPAD协议 */
  IPAD = "ipad",
  /** 微信 */
  WECHAT_PC = "pc",
  /** 艾客 */
  AIKE = "设备",
  /** WhatsApp */
  SALE_SMARTLY = "WhatsApp",
}

export enum ScaningStatus {
  /** 开始扫码 */
  SCANNING = "1",
  /** 在手机端点击了登录 */
  CLICK_LOGIN = "2",
  /** 在手机端取消了登录 */
  CANCEL_LOGIN = "4",
  /** 需要验证码验证登录 */
  NEED_VERIFY = "10",
  /** 需要在手机端确认登录 */
  NEED_CONFIRM_LOGIN = "11",
  /** 已登录 */
  LOGINED = "101",
}
export enum SendContentType {
  /** 文本类型 */
  "TEXT" = "TEXT",
  /** 图片类型 */
  "IMAGE" = "IMAGE",
  /** 视频类型 */
  "VIDEO" = "VIDEO",
  /** 文件类型 */
  "FILE" = "FILE",
  /** gif类型 */
  "GIF" = "GIF",
  /** 链接类型 */
  "LINK" = "LINK",
  /** 小程序类型 */
  "MINI_PROGRAM" = "MINI_PROGRAM",
  /** 好友卡片 */
  "BUSINESS_CARD" = "BUSINESS_CARD",
  /** 提及 */
  "MENTION" = "MENTION",
  /** 视频号 */
  "VIDEO_NUM" = "VIDEO_NUM",
}

export enum SendingStatus {
  /** 发送中 */
  SENDING = "SENDING",
  /** 发送失败 */
  FAIL = "FAIL",
  /** 发送成功 */
  SUCCESS = "SUCCESS",
}

export enum RelationshipEnum {
  /** 好友 奇数且status非2049，非-1 */
  FRIEND = "FRIEND",
  /** 对方删除  status 2049*/
  DELETE_BY_OTHER = "DELETE_BY_OTHER",
  /** 非好友 */
  NO_FRIEND = "NO_FRIEND",
}

export enum Sex {
  MALE = 1,
  FAMALE,
}

export enum LOGIN_STATUS {
  /** 掉线 */
  OFFLINE,
  /** 在线 */
  ONLINE,
}

export enum WS_REQUEST_MESSAGE_TYPE {
  // 打开企业微信
  OPEN = 1,
  /** 下线账号 */
  DOWNLINE = 2,
  /** 验证登录请求 */
  VERIFY_VERIFICATION_CODE = 1005,
  // 创建群聊
  CREATE_ROOM = 4000,
  // 退出群聊
  EXIT_ROOM = 4001,
  // 转让群主
  TRANSFER_ROOM_LEADER = 4002,
  /** 邀请好友进群 */
  INVITE_FRIEND_TO_ROOM = 4003,
  /** 移除群成员 */
  REMOVE_ROOM_MEMBER = 4005,
  // 修改群名
  UPDATE_ROOM_NAME = 4006,
  // 发布群公告
  PUBLISH_ROOM_NOTICE = 4007,
  // 解散群聊
  DISSOLVE_ROOM = 4009,
  // 查询历史消息
  GET_HISTORY_MESSAGE = 5303,
  // 发送文本
  SEND_TEXT = 5000,
  //  发送文本混合消息
  SEND_TEXT_MIXED = 5001,
  // 发送图片
  SEND_IMAGE = 5003,
  // 发送视频
  SEND_VIDEO = 5004,
  // 发送文件
  SEND_FILE = 5005,
  // 发送GIF
  SEND_GIF = 5006,
  // 发送链接
  SEND_LINK = 5007,
  // 发送小程序
  SEND_MINI_PROGRAM = 5008,
  // 发送名片
  SEND_BUSINESS_CARD = 5009,
  // 发送语音消息
  SEND_VOICE = 5010,
  /** 发送视频号 */
  SEND_VIDEO_NUM = 5011,
  /** 撤回消息 */
  REVOCATION_MESSAGE = 5300,
  /**  生成群聊二维码  */
  CREATE_ROOM_QRCODE = 6001,
  // 机器人托管
  ROBOT_TRUSTEESHIP = 10000,
  /** 通过好友申请 */
  ACCEPT_FRIEND = 3002,
  /** 删除好友 */
  DELETE_FRIEND = 3003,
  /** 修改联系人备注 */
  UPDATE_CONTACT_REMARK = 3004,
  /** 设置联系人描述 */
  UPDATE_CONTACT_DESC = 3006,
  /** 添加名片好友 */
  ADD_FRIEND_BY_BUSINESS_CARD = 3008,
  /** 添加主动删除的好友 */
  ADD_INITIATIVE_FRIEND = 3009,
  /** 添加被动删除的好友 */
  ADD_FRIEND = 3010,
  /** 当前登录用户所有有权限的企业微信账号 */
  GET_ALL_ACCOUNTS = 20000,
  /** 修改会话状态 */
  UPDATE_CONVERSATION_STATUS = 20003,
}

export enum WS_RESPONSE_MESSAGE_TYPE {
  /** 应用关闭通知 */
  CLIENT_CLOSE = 10002,
  /** 接收二维码 */
  RECEIVE_LOGIN_QRCODE = 11000,
  /** 登录成功通知 */
  LOGIN_SUCCESS = 11001,
  /** 登出通知 */
  LOGIN_OUT = 11002,
  /** 扫码通知 */
  SCANING = 11100,
  /** 验证登录请求 */
  VERIFY_VERIFICATION_CODE = 11005,
  /** 获取好友信息 */
  GET_CONTACT_DETAIL = 12001,
  /** 获取群成员 */
  GET_ROOM_DETAIL = 12503,
  /** 撤回消息   */
  REVOCATION_MESSAGE_SUCCESS_NOTICE = 15300,
  /** 发送消息 */
  RECEIVE_MESSAGE = 15000,
  /** 其他终端发送消息 */
  OTHER_TERMINAL_RECEIVE_MESSAGE = 15001,
  /** 消息撤回通知 */
  REVOCATION_MESSAGE_NOTICE = 15304,
  /** 文件下载成功通知 */
  FILE_DOWNLOAD_SUCCESS_NOTICE = 18006,
  /** 语音消息转文字通知 */
  VOICE_TO_TEXT_NOTICE = 15400,
  /** 好友删除通知 */
  FRIEND_DELETE_NOTICE = 15305,
  /** 通过好友申请 */
  ACCEPT_FRIEND = 13002,
  /** 接收好友申请 */
  RECEIVE_NEW_FRIEND_APPLY = 13100,
  /** 会话状态变更通知 */
  CONVERSATION_STATUS_CHANGE = 120003,
  /** 未读数更新 */
  UNREAD_NUM_UPDATE = 120001,
  /** 会话变更通知 */
  CONVERSATION_CHANGE = 120002,
  /** 创建群聊时，已删除客户添加到外部群时提醒 */
  REMOVE_CUSTOMER_TO_CREATE_ROOM = 14000,
  /** 群聊创建后时，已删除客户添加到外部群时提醒 */
  REMOVE_CUSTOMER_TO_CREATED_ROOM = 14003,
  /** 错误 */
  ERROR = 99999,
}

export interface ReceiveLoginQRCodeData {
  login_qrcode_key: string;
  url: string;
  ip?: string;
  client_id?: number;
}

export type ScaningData = {
  avator_url: string;
  corp_id: number;
  corp_logo: string;
  nickname: string;
  user_id: string;
  login_qrcode_key: string;
  login_status: ScaningStatus;
  error?: number;
  error_msg?: string;
  request_key?: string;
};

export type VerifyVerificationCodeData = {
  error_code?: number;
  error_msg?: string; //base64解码查看失败原因
  request_key: string;
};

export type AccountType = {
  avatar?: string;
  corpId?: string;
  corpShortName?: string;
  name?: string;
  userId: string;
  status?: LOGIN_STATUS;
  proxyType: ServiceType;
  unread?: number;
};

export enum RoomStatus {
  DISSOLVE = 0,
  EXIST = 1,
}

export enum MemberStatus {
  /** 不在群聊里面 */
  OUT,
  /** 在群聊里面 */
  IN,
}

/** 对话类型 */
export enum ChatType {
  /** 单聊 */
  SINGLE = "SINGLE",
  /**  群聊 */
  ROOM = "ROOM",
  /** 系统应用 */
  SYSTEM = "SYSTEM",
  /** 微信客服 */
  WECHAT_CUSTOMER_SERVICE = "WECHAT_CUSTOMER_SERVICE",
}

export * from "./wecom";
export * from "./wechat";
export * from "./mail";
export * from "./whatsapp";
